import React, {useEffect, useMemo} from 'react';
import {BrowserRouter as Router, Route, Routes, useLocation} from 'react-router-dom';
import LandingPage from "./pages/LandingPage/LandingPage";
import ErrorPage from "./pages/ErrorPage/ErrorPage";

// Хук для проверки валидности partner_id из параметров URL
function usePartnerValidation(): boolean {
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const partnerId = searchParams.get('partner_id');
    const success = searchParams.has('success');
    const failed = searchParams.has('failed');

    // Показываем модалку при наличии success или failed, иначе проверяем валидность partnerId
    return success || failed || (partnerId && !isNaN(Number(partnerId)) && Number(partnerId) > 0) as boolean;
}

const MainComponent: React.FC = () => {
    const isPartnerValid = usePartnerValidation();

    useEffect(() => {
        document.title = isPartnerValid ? "ELS GROUP" : "404 - Страница не найдена"; // Устанавливаем заголовок
    }, [isPartnerValid]);

    return (
        <div className="App">
            {isPartnerValid ? <LandingPage/> : <ErrorPage/>}
        </div>
    );
}


const Error404: React.FC = () => {
    useEffect(() => {
        document.title = "404 - Страница не найдена"; // Устанавливаем заголовок
    }, []);

    return <ErrorPage/>;
}

const App: React.FC = () => {
    return (
        <Router basename="/svoy_v_alfe_5">
            <Routes>
                <Route path="/" element={<MainComponent/>}/>
                <Route path="*" element={<Error404/>}/> {/* Обрабатываем все остальные маршруты */}
            </Routes>
        </Router>
    );
}

export default App;
